/**
 * Dark Mode Semantic Tokens
 *
 * Generated from figma-exports/modedark.css.
 * Edit the source CSS and re-run the figma-token-sync skill — do not hand-edit.
 *
 * Structure: palette.ts → tokens-dark.ts / tokens-light.ts → component-tokens.ts
 */

import { palette } from './palette';

const { neutrals, color, special } = palette;

export const tokensDark = {
  background: {
    basic: {
      clear: neutrals.clear,
      black: neutrals.duskwraithA[1000],
      white: neutrals.pureWhite[1000],
    },
    neutral: {
      canvas: {
        base: color.blue.brandPrimaryA[1000],
      },
      raised: {
        base: neutrals.echoLightA[1000],
        1: neutrals.echoLightA[900],
        2: neutrals.echoLightA[600],
        3: neutrals.echoLightA[400],
        4: neutrals.echoLightA[300],
        5: neutrals.echoLightA[100],
        6: neutrals.echoLightA[50],
        7: neutrals.echoLightA[50],
      },
      inverse: {
        raised: {
          base: neutrals.duskwraithA[1000],
          1: neutrals.duskwraithA[900],
          2: neutrals.duskwraithA[700],
          3: neutrals.duskwraithA[500],
          4: neutrals.duskwraithA[300],
          5: neutrals.duskwraithA[200],
          6: neutrals.duskwraithA[50],
        },
        raisedToBrand: {
          base: neutrals.duskwraithA[1000],
          1: neutrals.duskwraithA[900],
          2: neutrals.duskwraithA[700],
          3: neutrals.duskwraithA[500],
          4: neutrals.duskwraithA[300],
          5: neutrals.duskwraithA[200],
          6: neutrals.duskwraithA[50],
        },
      },
      mid: {
        base: neutrals.grayBlueA[1000],
        1: neutrals.grayBlueA[900],
        2: neutrals.grayBlueA[600],
        3: neutrals.grayBlueA[400],
        4: neutrals.grayBlueA[300],
        5: neutrals.grayBlueA[100],
        6: neutrals.grayBlueA[50],
      },
      midToBrand: {
        base: neutrals.grayBlueA[1000],
        1: neutrals.grayBlueA[900],
        2: neutrals.grayBlueA[600],
        3: neutrals.grayBlueA[400],
        4: neutrals.grayBlueA[300],
        5: neutrals.grayBlueA[100],
        6: neutrals.grayBlueA[50],
      },
      midToWhite: {
        base: neutrals.grayBlueA[1000],
        1: neutrals.grayBlueA[900],
        2: neutrals.grayBlueA[600],
        3: neutrals.grayBlueA[400],
        4: neutrals.grayBlueA[300],
        5: neutrals.grayBlueA[100],
        6: neutrals.grayBlueA[50],
      },
    },
    brand: {
      dark: {
        base: color.blue.brandPrimaryA[1000],
        1: color.blue.brandPrimaryA[900],
        2: color.blue.brandPrimaryA[700],
        3: color.blue.brandPrimaryA[500],
        4: color.blue.brandPrimaryA[300],
        5: color.blue.brandPrimaryA[200],
      },
      blue: {
        base: color.blue.secondaryBlueA[1000],
        1: color.blue.secondaryBlueA[900],
        2: color.blue.secondaryBlueA[800],
        3: color.blue.secondaryBlueA[500],
        4: color.blue.secondaryBlueA[400],
        5: color.blue.secondaryBlueA[200],
      },
    },
    secondary: {
      base: color.blue.secondaryBlueA[1000],
      1: color.blue.secondaryBlueA[900],
      2: color.blue.secondaryBlueA[800],
      3: color.blue.secondaryBlueA[500],
      4: color.blue.secondaryBlueA[400],
      5: color.blue.secondaryBlueA[200],
    },
    semantic: {
      success: {
        base: color.green.ionSproutA[1000],
        1: color.green.ionSproutA[900],
        2: color.green.ionSproutA[700],
        3: color.green.ionSproutA[500],
        4: color.green.ionSproutA[400],
        5: color.green.ionSproutA[200],
      },
      warning: {
        base: color.orange.warmA[1000],
        1: color.orange.warmA[900],
        2: color.orange.warmA[700],
        3: color.orange.warmA[500],
        4: color.orange.warmA[400],
        5: color.orange.warmA[200],
      },
      error: {
        base: color.red.malachorA[900],
        1: color.red.malachorA[700],
        2: color.red.malachorA[500],
        3: color.red.malachorA[300],
        4: color.red.malachorA[200],
        5: color.red.malachorA[100],
      },
      info: {
        base: color.blue.skyboltA[1000],
        1: color.blue.skyboltA[900],
        2: color.blue.skyboltA[700],
        3: color.blue.skyboltA[500],
        4: color.blue.skyboltA[400],
        5: color.blue.skyboltA[200],
      },
      suggest: {
        base: color.yellow.sunnyA[1000],
        1: color.yellow.sunnyA[900],
        2: color.yellow.sunnyA[700],
        3: color.yellow.sunnyA[500],
        4: color.yellow.sunnyA[400],
        5: color.yellow.sunnyA[200],
      },
    },
    accent: {
      1: {
        base: color.blue.lightA[1000],
        1: color.blue.lightA[800],
        2: color.blue.lightA[600],
        3: color.blue.lightA[500],
        4: color.blue.lightA[400],
        5: color.blue.lightA[300],
        6: color.blue.lightA[200],
      },
      2: {
        base: color.purple.violetA[1000],
        1: color.purple.violetA[900],
        2: color.purple.violetA[700],
        3: color.purple.violetA[500],
        4: color.purple.violetA[400],
        5: color.purple.violetA[200],
      },
      3: {
        base: color.teal.sunsparkOasisA[1000],
        1: color.teal.sunsparkOasisA[900],
        2: color.teal.sunsparkOasisA[700],
        3: color.teal.sunsparkOasisA[500],
        4: color.teal.sunsparkOasisA[400],
        5: color.teal.sunsparkOasisA[200],
      },
      4: {
        base: color.orange.sunstreakA[1000],
        1: color.orange.sunstreakA[900],
        2: color.orange.sunstreakA[700],
        3: color.orange.sunstreakA[500],
        4: color.orange.sunstreakA[400],
        5: color.orange.sunstreakA[200],
      },
      5: {
        base: color.yellow.twinSunlightA[1000],
        1: color.yellow.twinSunlightA[900],
        2: color.yellow.twinSunlightA[700],
        3: color.yellow.twinSunlightA[500],
        4: color.yellow.twinSunlightA[400],
        5: color.yellow.twinSunlightA[200],
      },
      6: {
        base: color.blue.electricBlueA[1000],
        1: color.blue.electricBlueA[900],
        2: color.blue.electricBlueA[700],
        3: color.blue.electricBlueA[500],
        4: color.blue.electricBlueA[400],
        5: color.blue.electricBlueA[200],
      },
      7: {
        base: color.orange.amberA[1000],
        1: color.orange.amberA[900],
        2: color.orange.amberA[700],
        3: color.orange.amberA[500],
        4: color.orange.amberA[400],
        5: color.orange.amberA[200],
      },
      8: {
        base: color.purple.deepPurpA[1000],
        1: color.purple.deepPurpA[900],
        2: color.purple.deepPurpA[700],
        3: color.purple.deepPurpA[500],
        4: color.purple.deepPurpA[400],
        5: color.purple.deepPurpA[200],
      },
      9: {
        base: color.magenta.magentaA[1000],
        1: color.magenta.magentaA[900],
        2: color.magenta.magentaA[700],
        3: color.magenta.magentaA[500],
        4: color.magenta.magentaA[400],
        5: color.magenta.magentaA[200],
      },
      10: {
        base: color.green.forestA[1000],
        1: color.green.forestA[900],
        2: color.green.forestA[700],
        3: color.green.forestA[500],
        4: color.green.forestA[400],
        5: color.green.forestA[200],
      },
      11: {
        base: color.orange.pumpkinA[1000],
        1: color.orange.pumpkinA[900],
        2: color.orange.pumpkinA[700],
        3: color.orange.pumpkinA[500],
        4: color.orange.pumpkinA[400],
        5: color.orange.pumpkinA[200],
      },
      12: {
        base: color.yellow.sunnyA[1000],
        1: color.yellow.sunnyA[900],
        2: color.yellow.sunnyA[700],
        3: color.yellow.sunnyA[500],
        4: color.yellow.sunnyA[400],
        5: color.yellow.sunnyA[200],
      },
      13: {
        base: color.teal.mintyA[1000],
        1: color.teal.mintyA[900],
        2: color.teal.mintyA[700],
        3: color.teal.mintyA[500],
        4: color.teal.mintyA[400],
        5: color.teal.mintyA[200],
      },
      14: {
        base: color.blue.neptuneA[1000],
        1: color.blue.neptuneA[900],
        2: color.blue.neptuneA[700],
        3: color.blue.neptuneA[500],
        4: color.blue.neptuneA[400],
        5: color.blue.neptuneA[200],
      },
      15: {
        base: color.green.emeraldSaberA[1000],
        1: color.green.emeraldSaberA[900],
        2: color.green.emeraldSaberA[700],
        3: color.green.emeraldSaberA[500],
        4: color.green.emeraldSaberA[400],
        5: color.green.emeraldSaberA[200],
      },
      16: {
        base: color.blue.lightA[1000],
        1: color.blue.lightA[700],
        2: color.blue.lightA[600],
        3: color.blue.lightA[500],
        4: color.blue.lightA[300],
        5: color.blue.lightA[200],
      },
    },
    skeleton: {
      base: neutrals.grayBlueA[600],
      wave: neutrals.grayBlueA[400],
    },
  },
  backgroundO: {
    basic: {
      clear: neutrals.clear,
      black: neutrals.duskwraithA[1000],
      white: neutrals.pureWhite[1000],
    },
    neutral: {
      canvas: {
        base: color.blue.brandPrimaryO[1000],
        panel: color.blue.navy[850],
      },
      raised: {
        base: neutrals.echoLightO[1000],
        1: neutrals.echoLightO[900],
        2: neutrals.echoLightO[600],
        3: neutrals.echoLightO[400],
        4: neutrals.echoLightO[300],
        5: neutrals.echoLightO[200],
        6: neutrals.echoLightO[100],
        7: neutrals.echoLightO[50],
      },
      inverse: {
        raised: {
          base: neutrals.duskwraithO[1000],
          1: neutrals.duskwraithO[900],
          2: neutrals.duskwraithO[700],
          3: neutrals.duskwraithO[500],
          4: neutrals.duskwraithO[300],
          5: neutrals.duskwraithO[200],
          6: neutrals.duskwraithO[50],
        },
        raisedToBrand: {
          base: neutrals.duskwraithO[1000],
          1: neutrals.duskwraithO[900],
          2: neutrals.duskwraithO[700],
          3: neutrals.duskwraithO[500],
          4: neutrals.duskwraithO[300],
          5: neutrals.duskwraithO[200],
          6: neutrals.duskwraithO[50],
        },
      },
      mid: {
        base: neutrals.grayBlueO[1000],
        1: neutrals.grayBlueO[950],
        2: neutrals.grayBlueO[900],
        3: neutrals.grayBlueO[800],
        4: neutrals.grayBlueO[700],
        5: neutrals.grayBlueO[600],
        6: neutrals.grayBlueO[500],
        d3: neutrals.grayBlueO[1300],
        d2: neutrals.grayBlueO[1200],
        d1: neutrals.grayBlueO[1100],
      },
      midToBrand: {
        base: neutrals.grayBlueO[1300],
        1: neutrals.grayBlueO[1200],
        2: neutrals.grayBlueO[1100],
        3: neutrals.grayBlueO[1000],
        4: neutrals.grayBlueO[950],
        5: neutrals.grayBlueO[900],
        6: neutrals.grayBlueO[800],
      },
      midToWhite: {
        base: neutrals.grayBlueO[1000],
        1: neutrals.grayBlueO[900],
        2: neutrals.grayBlueO[600],
        3: neutrals.grayBlueO[400],
        4: neutrals.grayBlueO[300],
        5: neutrals.grayBlueO[100],
        6: neutrals.grayBlueO[50],
        d3: neutrals.grayBlueO[1300],
        d2: neutrals.grayBlueO[1200],
        d1: neutrals.grayBlueO[1100],
      },
    },
    brand: {
      dark: {
        base: color.blue.brandPrimaryO[1200],
        1: color.blue.brandPrimaryO[1100],
        2: color.blue.brandPrimaryO[1000],
        3: color.blue.brandPrimaryO[950],
        4: color.blue.brandPrimaryO[900],
        5: color.blue.brandPrimaryO[800],
      },
      blue: {
        base: color.blue.secondaryBlueO[1000],
        1: color.blue.secondaryBlueO[950],
        2: color.blue.secondaryBlueO[900],
        3: color.blue.secondaryBlueO[800],
        4: color.blue.secondaryBlueO[700],
        5: color.blue.secondaryBlueO[600],
        d3: color.blue.secondaryBlueO[1300],
        d2: color.blue.secondaryBlueO[1200],
        d1: color.blue.secondaryBlueO[1100],
      },
    },
    semantic: {
      success: {
        base: color.green.ionSproutO[1000],
        1: color.green.ionSproutO[950],
        2: color.green.ionSproutO[900],
        3: color.green.ionSproutO[800],
        4: color.green.ionSproutO[700],
        5: color.green.ionSproutO[600],
        d3: color.green.ionSproutO[1300],
        d2: color.green.ionSproutO[1200],
        d1: color.green.ionSproutO[1100],
      },
      warning: {
        base: color.orange.warmO[950],
        1: color.orange.warmO[900],
        2: color.orange.warmO[800],
        3: color.orange.warmO[700],
        4: color.orange.warmO[600],
        5: color.orange.warmO[500],
        d3: color.orange.warmO[1200],
        d2: color.orange.warmO[1100],
        d1: color.orange.warmO[1000],
      },
      error: {
        base: color.red.malachorO[900],
        1: color.red.malachorO[800],
        2: color.red.malachorO[700],
        3: color.red.malachorO[600],
        4: color.red.malachorO[500],
        5: color.red.malachorO[400],
        d4: color.red.malachorO[1200],
        d3: color.red.malachorO[1100],
        d2: color.red.malachorO[1000],
        d1: color.red.malachorO[950],
      },
      info: {
        base: color.blue.skyboltO[950],
        1: color.blue.skyboltO[900],
        2: color.blue.skyboltO[800],
        3: color.blue.skyboltO[700],
        4: color.blue.skyboltO[600],
        5: color.blue.skyboltO[500],
        d3: color.blue.skyboltO[1200],
        d2: color.blue.skyboltO[1100],
        d1: color.blue.skyboltO[1000],
      },
      suggest: {
        base: color.yellow.sunnyO[950],
        1: color.yellow.sunnyO[900],
        2: color.yellow.sunnyO[800],
        3: color.yellow.sunnyO[700],
        4: color.yellow.sunnyO[600],
        5: color.yellow.sunnyO[500],
        d3: color.yellow.sunnyO[1200],
        d2: color.yellow.sunnyO[1100],
        d1: color.yellow.sunnyO[1000],
      },
    },
    accent: {
      1: {
        base: color.blue.lightO[1000],
        1: color.blue.lightO[900],
        2: color.blue.lightO[700],
        3: color.blue.lightO[600],
        4: color.blue.lightO[500],
        5: color.blue.lightO[300],
        6: color.blue.lightO[200],
      },
      2: {
        base: color.purple.violetO[950],
        1: color.purple.violetO[900],
        2: color.purple.violetO[700],
        3: color.purple.violetO[600],
        4: color.purple.violetO[500],
        5: color.purple.violetO[300],
      },
      3: {
        base: color.teal.sunsparkOasisO[1000],
        1: color.teal.sunsparkOasisO[900],
        2: color.teal.sunsparkOasisO[700],
        3: color.teal.sunsparkOasisO[600],
        4: color.teal.sunsparkOasisO[500],
        5: color.teal.sunsparkOasisO[300],
      },
      4: {
        base: color.orange.sunstreakO[1000],
        1: color.orange.sunstreakO[900],
        2: color.orange.sunstreakO[700],
        3: color.orange.sunstreakO[600],
        4: color.orange.sunstreakO[500],
        5: color.orange.sunstreakO[300],
      },
      5: {
        base: color.yellow.twinSunlightO[1000],
        1: color.yellow.twinSunlightO[900],
        2: color.yellow.twinSunlightO[700],
        3: color.yellow.twinSunlightO[600],
        4: color.yellow.twinSunlightO[500],
        5: color.yellow.twinSunlightO[300],
      },
      6: {
        base: color.blue.electricBlueO[1000],
        1: color.blue.electricBlueO[900],
        2: color.blue.electricBlueO[700],
        3: color.blue.electricBlueO[600],
        4: color.blue.electricBlueO[500],
        5: color.blue.electricBlueO[300],
      },
      7: {
        base: color.orange.amberO[1000],
        1: color.orange.amberO[900],
        2: color.orange.amberO[700],
        3: color.orange.amberO[600],
        4: color.orange.amberO[500],
        5: color.orange.amberO[300],
      },
      8: {
        base: color.purple.deepPurpO[1000],
        1: color.purple.deepPurpO[900],
        2: color.purple.deepPurpO[700],
        3: color.purple.deepPurpO[600],
        4: color.purple.deepPurpO[500],
        5: color.purple.deepPurpO[300],
      },
      9: {
        base: color.magenta.magentaO[1000],
        1: color.magenta.magentaO[900],
        2: color.magenta.magentaO[700],
        3: color.magenta.magentaO[600],
        4: color.magenta.magentaO[500],
        5: color.magenta.magentaO[300],
      },
      10: {
        base: color.green.forestO[1000],
        1: color.green.forestO[900],
        2: color.green.forestO[700],
        3: color.green.forestO[600],
        4: color.green.forestO[500],
        5: color.green.forestO[300],
      },
      11: {
        base: color.orange.pumpkinO[1000],
        1: color.orange.pumpkinO[900],
        2: color.orange.pumpkinO[700],
        3: color.orange.pumpkinO[600],
        4: color.orange.pumpkinO[500],
        5: color.orange.pumpkinO[300],
      },
      12: {
        base: color.yellow.sunnyO[1000],
        1: color.yellow.sunnyO[900],
        2: color.yellow.sunnyO[700],
        3: color.yellow.sunnyO[600],
        4: color.yellow.sunnyO[500],
        5: color.yellow.sunnyO[300],
      },
      13: {
        base: color.teal.mintyO[1000],
        1: color.teal.mintyO[900],
        2: color.teal.mintyO[700],
        3: color.teal.mintyO[600],
        4: color.teal.mintyO[500],
        5: color.teal.mintyO[300],
      },
      14: {
        base: color.blue.neptuneO[1000],
        1: color.blue.neptuneO[900],
        2: color.blue.neptuneO[700],
        3: color.blue.neptuneO[600],
        4: color.blue.neptuneO[500],
        5: color.blue.neptuneO[300],
      },
      15: {
        base: color.green.emeraldSaberO[1000],
        1: color.green.emeraldSaberO[900],
        2: color.green.emeraldSaberO[700],
        3: color.green.emeraldSaberO[600],
        4: color.green.emeraldSaberO[500],
        5: color.green.emeraldSaberO[300],
      },
      16: {
        base: color.blue.lightO[1000],
        1: color.blue.lightO[900],
        2: color.blue.lightO[700],
        3: color.blue.lightO[600],
        4: color.blue.lightO[500],
        5: color.blue.lightO[300],
      },
    },
  },
  content: {
    text: {
      basic: {
        clear: neutrals.clear,
        black: neutrals.duskwraithA[1000],
        white: neutrals.pureWhite[1000],
      },
      neutral: {
        base: neutrals.echoLightA[1000],
        1: neutrals.echoLightA[900],
        2: neutrals.echoLightA[800],
        3: neutrals.echoLightA[600],
        4: neutrals.echoLightA[300],
        5: neutrals.echoLightA[200],
      },
      static: {
        base: neutrals.echoLightA[1000],
        1: neutrals.echoLightA[900],
        2: neutrals.echoLightA[800],
        3: neutrals.echoLightA[600],
        4: neutrals.echoLightA[300],
        5: neutrals.echoLightA[200],
      },
      on: {
        color: {
          dark: {
            dark: neutrals.duskwraithA[1000],
            light: neutrals.duskwraithA[1000],
          },
          light: {
            dark: neutrals.echoLightA[1000],
            light: neutrals.echoLightA[1000],
          },
        },
      },
      inverse: {
        base: neutrals.grayBlueA[1000],
        1: neutrals.grayBlueA[900],
        2: neutrals.grayBlueA[800],
        3: neutrals.grayBlueA[500],
        4: neutrals.grayBlueA[300],
        5: neutrals.grayBlueA[200],
      },
      brand: {
        base: color.blue.brandPrimaryA[1000],
        1: color.blue.brandPrimaryA[700],
        2: color.blue.brandPrimaryA[300],
        3: color.blue.brandPrimaryA[200],
        4: color.blue.brandPrimaryA[100],
        5: color.blue.brandPrimaryA[50],
      },
      code: {
        punctuation: {
          base: special.code1[200],
          1: special.code1[300],
          2: special.code1[400],
          3: special.code1[500],
        },
        constant: {
          base: special.code2[200],
          1: special.code2[300],
          2: special.code2[400],
          3: special.code2[500],
        },
        entity: {
          base: special.code3[200],
          1: special.code3[300],
          2: special.code3[400],
          3: special.code3[500],
          other: {
            inheritedClass: {
              base: special.code12[200],
              1: special.code12[300],
              2: special.code12[400],
              3: special.code12[500],
            },
          },
        },
        keyword: {
          base: special.code4[200],
          1: special.code4[300],
          2: special.code4[400],
          3: special.code4[500],
        },
        storage: {
          base: special.code5[200],
          1: special.code5[300],
          2: special.code5[400],
          3: special.code5[500],
        },
        unquoted: {
          oldplist: {
            base: special.code6[200],
            1: special.code6[300],
            2: special.code6[400],
            3: special.code6[500],
          },
        },
        comment: {
          base: special.code7[200],
          1: special.code7[300],
          2: special.code7[400],
          3: special.code7[500],
        },
        support: {
          base: special.code8[200],
          1: special.code8[300],
          2: special.code8[400],
          3: special.code8[500],
          function: {
            base: special.code17[200],
            1: special.code17[300],
            2: special.code17[400],
            3: special.code17[500],
          },
          constant: {
            base: special.code18[200],
            1: special.code18[300],
            2: special.code18[400],
            3: special.code18[500],
          },
          type: {
            exception: {
              base: special.code19[200],
              1: special.code19[300],
              2: special.code19[400],
              3: special.code19[500],
            },
            propertyName: {
              base: special.code26[200],
              1: special.code26[300],
              2: special.code26[400],
              3: special.code26[500],
            },
          },
        },
        variable: {
          base: special.code9[200],
          1: special.code9[300],
          2: special.code9[400],
          3: special.code9[500],
          language: {
            base: special.code10[200],
            1: special.code10[300],
            2: special.code10[400],
            3: special.code10[500],
          },
        },
        escape: {
          invalid: {
            base: special.code11[200],
            1: special.code11[300],
            2: special.code11[400],
            3: special.code11[500],
          },
        },
        quoted: {
          source: {
            base: special.code13[200],
            1: special.code13[300],
            2: special.code13[400],
            3: special.code13[500],
          },
        },
        string: {
          constant: {
            base: special.code14[200],
            1: special.code14[300],
            2: special.code14[400],
            3: special.code14[500],
          },
          regexp: {
            base: special.code15[200],
            1: special.code15[300],
            2: special.code15[400],
            3: special.code15[500],
          },
          variable: {
            base: special.code16[200],
            1: special.code16[300],
            2: special.code16[400],
            3: special.code16[500],
          },
        },
        meta: {
          preprocessor: {
            c: {
              base: special.code20[200],
              1: special.code20[300],
              2: special.code20[400],
              3: special.code20[500],
              keyword: {
                base: special.code21[200],
                1: special.code21[300],
                2: special.code21[400],
                3: special.code21[500],
              },
            },
          },
          sgmlhtml: {
            meta: {
              doctype: {
                base: special.code22[200],
                1: special.code22[300],
                2: special.code22[400],
                3: special.code22[500],
              },
            },
          },
          tag: {
            base: special.code23[200],
            1: special.code23[300],
            2: special.code23[400],
            3: special.code23[500],
          },
          attributeName: {
            id: {
              base: special.code24[200],
              1: special.code24[300],
              2: special.code24[400],
              3: special.code24[500],
            },
            class: {
              base: special.code25[200],
              1: special.code25[300],
              2: special.code25[400],
              3: special.code25[500],
            },
          },
          propertyValue: {
            css: {
              base: special.code27[200],
              1: special.code27[300],
              2: special.code27[400],
              3: special.code27[500],
            },
          },
          control: {
            atRule: {
              base: special.code28[200],
              1: special.code28[300],
              2: special.code28[400],
              3: special.code28[500],
            },
          },
          namedColor: {
            css: {
              2: {
                base: special.code29[200],
                1: special.code29[300],
                2: special.code29[400],
                3: special.code29[500],
              },
            },
          },
        },
        markup: {
          bold: {
            base: special.code30[200],
            1: special.code30[300],
            2: special.code30[400],
            3: special.code30[500],
          },
          italic: {
            base: special.code31[200],
            1: special.code31[300],
            2: special.code31[400],
            3: special.code31[500],
          },
          heading: {
            base: special.code32[200],
            1: special.code32[300],
            2: special.code32[400],
            3: special.code32[500],
          },
        },
      },
      semantic: {
        success: {
          base: color.green.limegreenO[600],
          1: color.green.limegreenO[500],
          2: color.green.limegreenO[400],
          3: color.green.limegreenO[300],
          4: color.green.limegreenO[200],
          5: color.green.limegreenO[100],
        },
        warning: {
          base: color.orange.burntSiennaO[600],
          1: color.orange.burntSiennaO[700],
          2: color.orange.burntSiennaO[800],
          3: color.orange.burntSiennaO[900],
          4: color.orange.burntSiennaO[950],
          5: color.orange.burntSiennaO[1000],
        },
        error: {
          base: color.red.crimsonO[500],
          1: color.red.crimsonO[400],
          2: color.red.crimsonO[300],
          3: color.red.crimsonO[200],
          4: color.red.crimsonO[100],
          5: color.red.crimsonO[50],
        },
        info: {
          base: color.blue.skyblueO[600],
          1: color.blue.skyblueO[700],
          2: color.blue.skyblueO[800],
          3: color.blue.skyblueO[900],
          4: color.blue.skyblueO[950],
          5: color.blue.skyblueO[1000],
        },
        suggest: {
          base: color.yellow.eggshellO[600],
          1: color.yellow.eggshellO[700],
          2: color.yellow.eggshellO[800],
          3: color.yellow.eggshellO[900],
          4: color.yellow.eggshellO[950],
          5: color.yellow.eggshellO[1000],
        },
      },
      accent: {
        1: {
          base: color.blue.lightA[1000],
          1: color.blue.lightA[900],
          2: color.blue.lightA[800],
          3: color.blue.lightA[600],
          4: color.blue.lightA[300],
          5: color.blue.lightA[200],
        },
        2: {
          base: color.purple.violetA[1000],
          1: color.purple.violetA[900],
          2: color.purple.violetA[800],
          3: color.purple.violetA[600],
          4: color.purple.violetA[300],
          5: color.purple.violetA[200],
        },
        3: {
          base: color.teal.sunsparkOasisA[1000],
          1: color.teal.sunsparkOasisA[900],
          2: color.teal.sunsparkOasisA[800],
          3: color.teal.sunsparkOasisA[600],
          4: color.teal.sunsparkOasisA[300],
          5: color.teal.sunsparkOasisA[200],
        },
        4: {
          base: color.orange.sunstreakA[1000],
          1: color.orange.sunstreakA[900],
          2: color.orange.sunstreakA[800],
          3: color.orange.sunstreakA[600],
          4: color.orange.sunstreakA[300],
          5: color.orange.sunstreakA[200],
        },
        8: {
          base: color.purple.deepPurpA[1000],
          1: color.purple.deepPurpA[900],
          2: color.purple.deepPurpA[800],
          3: color.purple.deepPurpA[600],
          4: color.purple.deepPurpA[300],
          5: color.purple.deepPurpA[200],
        },
        14: {
          base: color.blue.neptuneA[1000],
          1: color.blue.neptuneA[900],
          2: color.blue.neptuneA[800],
          3: color.blue.neptuneA[600],
          4: color.blue.neptuneA[300],
          5: color.blue.neptuneA[200],
        },
        15: {
          base: color.green.emeraldSaberA[1000],
          1: color.green.emeraldSaberA[900],
          2: color.green.emeraldSaberA[800],
          3: color.green.emeraldSaberA[600],
          4: color.green.emeraldSaberA[300],
          5: color.green.emeraldSaberA[200],
        },
        16: {
          base: color.purple.fuchsiaA[1000],
          1: color.purple.fuchsiaA[900],
          2: color.purple.fuchsiaA[800],
          3: color.purple.fuchsiaA[600],
          4: color.purple.fuchsiaA[300],
          5: color.purple.fuchsiaA[200],
        },
      },
    },
    assets: {
      basic: {
        clear: neutrals.clear,
        black: neutrals.duskwraithA[1000],
        white: neutrals.pureWhite[1000],
      },
      neutral: {
        base: neutrals.echoLightA[1000],
        1: neutrals.echoLightA[900],
        2: neutrals.echoLightA[800],
        3: neutrals.echoLightA[700],
        4: neutrals.echoLightA[500],
        5: neutrals.echoLightA[300],
      },
      on: {
        color: {
          dark: {
            dark: neutrals.duskwraithA[1000],
            light: neutrals.duskwraithA[1000],
          },
          light: {
            dark: neutrals.echoLightA[1000],
            light: neutrals.echoLightA[1000],
          },
        },
      },
      inverse: {
        base: neutrals.duskwraithA[1000],
        1: neutrals.duskwraithA[900],
        2: neutrals.duskwraithA[800],
        3: neutrals.duskwraithA[500],
        4: neutrals.duskwraithA[300],
        5: neutrals.duskwraithA[200],
      },
      brand: {
        base: color.blue.brandPrimaryA[1000],
        1: color.blue.brandPrimaryA[900],
        2: color.blue.brandPrimaryA[800],
        3: color.blue.brandPrimaryA[700],
        4: color.blue.brandPrimaryA[500],
        5: color.blue.brandPrimaryA[200],
      },
      secondary: {
        base: color.blue.secondaryBlueA[1000],
        1: color.blue.secondaryBlueA[900],
        2: color.blue.secondaryBlueA[800],
        3: color.blue.secondaryBlueA[500],
        4: color.blue.secondaryBlueA[300],
        5: color.blue.secondaryBlueA[200],
      },
      semantic: {
        success: {
          base: color.green.limegreenO[600],
          1: color.green.limegreenO[500],
          2: color.green.limegreenO[400],
          3: color.green.limegreenO[300],
          4: color.green.limegreenO[200],
          5: color.green.limegreenO[100],
        },
        warning: {
          base: color.orange.burntSiennaO[600],
          1: color.orange.burntSiennaO[700],
          2: color.orange.burntSiennaO[800],
          3: color.orange.burntSiennaO[900],
          4: color.orange.burntSiennaO[950],
          5: color.orange.burntSiennaO[1000],
        },
        error: {
          base: color.red.crimsonO[500],
          1: color.red.crimsonO[400],
          2: color.red.crimsonO[300],
          3: color.red.crimsonO[200],
          4: color.red.crimsonO[100],
          5: color.red.crimsonO[50],
        },
        info: {
          base: color.blue.skyblueO[600],
          1: color.blue.skyblueO[700],
          2: color.blue.skyblueO[800],
          3: color.blue.skyblueO[900],
          4: color.blue.skyblueO[950],
          5: color.blue.skyblueO[1000],
        },
        suggest: {
          base: color.yellow.eggshellO[600],
          1: color.yellow.eggshellO[700],
          2: color.yellow.eggshellO[800],
          3: color.yellow.eggshellO[900],
          4: color.yellow.eggshellO[950],
          5: color.yellow.eggshellO[1000],
        },
      },
      accent: {
        1: {
          base: color.blue.lightA[1000],
          1: color.blue.lightA[900],
          2: color.blue.lightA[800],
          3: color.blue.lightA[600],
          4: color.blue.lightA[400],
          5: color.blue.lightA[200],
          6: color.blue.lightA[50],
        },
        2: {
          base: color.purple.violetA[1000],
          1: color.purple.violetA[700],
          2: color.purple.violetA[500],
          3: color.purple.violetA[400],
          4: color.purple.violetA[200],
          5: color.purple.violetA[50],
        },
        3: {
          base: color.teal.sunsparkOasisA[1000],
          1: color.teal.sunsparkOasisA[700],
          2: color.teal.sunsparkOasisA[500],
          3: color.teal.sunsparkOasisA[400],
          4: color.teal.sunsparkOasisA[200],
          5: color.teal.sunsparkOasisA[50],
        },
        4: {
          base: color.orange.sunstreakA[1000],
          1: color.orange.sunstreakA[700],
          2: color.orange.sunstreakA[500],
          3: color.orange.sunstreakA[400],
          4: color.orange.sunstreakA[200],
          5: color.orange.sunstreakA[50],
        },
        5: {
          base: color.yellow.twinSunlightA[1000],
          1: color.yellow.twinSunlightA[700],
          2: color.yellow.twinSunlightA[500],
          3: color.yellow.twinSunlightA[400],
          4: color.yellow.twinSunlightA[200],
          5: color.yellow.twinSunlightA[50],
        },
        6: {
          base: color.blue.electricBlueA[1000],
          1: color.blue.electricBlueA[700],
          2: color.blue.electricBlueA[500],
          3: color.blue.electricBlueA[400],
          4: color.blue.electricBlueA[200],
          5: color.blue.electricBlueA[50],
        },
        7: {
          base: color.orange.amberA[1000],
          1: color.orange.amberA[700],
          2: color.orange.amberA[500],
          3: color.orange.amberA[400],
          4: color.orange.amberA[200],
          5: color.orange.amberA[50],
        },
        8: {
          base: color.purple.deepPurpA[1000],
          1: color.purple.deepPurpA[700],
          2: color.purple.deepPurpA[500],
          3: color.purple.deepPurpA[400],
          4: color.purple.deepPurpA[200],
          5: color.purple.deepPurpA[50],
        },
        9: {
          base: color.magenta.magentaA[1000],
          1: color.magenta.magentaA[700],
          2: color.magenta.magentaA[500],
          3: color.magenta.magentaA[400],
          4: color.magenta.magentaA[200],
          5: color.magenta.magentaA[50],
        },
        10: {
          base: color.green.forestA[1000],
          1: color.green.forestA[700],
          2: color.green.forestA[500],
          3: color.green.forestA[400],
          4: color.green.forestA[200],
          5: color.green.forestA[50],
        },
        11: {
          base: color.orange.pumpkinA[1000],
          1: color.orange.pumpkinA[700],
          2: color.orange.pumpkinA[500],
          3: color.orange.pumpkinA[400],
          4: color.orange.pumpkinA[200],
          5: color.orange.pumpkinA[50],
        },
        12: {
          base: color.yellow.sunnyA[1000],
          1: color.yellow.sunnyA[700],
          2: color.yellow.sunnyA[500],
          3: color.yellow.sunnyA[400],
          4: color.yellow.sunnyA[200],
          5: color.yellow.sunnyA[50],
        },
        13: {
          base: color.teal.mintyA[1000],
          1: color.teal.mintyA[700],
          2: color.teal.mintyA[500],
          3: color.teal.mintyA[400],
          4: color.teal.mintyA[200],
          5: color.teal.mintyA[50],
        },
        14: {
          base: color.blue.neptuneA[1000],
          1: color.blue.neptuneA[700],
          2: color.blue.neptuneA[500],
          3: color.blue.neptuneA[400],
          4: color.blue.neptuneA[200],
          5: color.blue.neptuneA[50],
        },
      },
    },
  },
  contentO: {
    text: {
      basic: {
        clear: neutrals.clear,
        black: neutrals.duskwraithA[1000],
        white: neutrals.pureWhite[1000],
      },
      neutral: {
        base: neutrals.echoLightO[800],
        1: neutrals.echoLightO[1000],
        2: neutrals.echoLightO[1100],
        3: neutrals.echoLightO[1200],
      },
      static: {
        base: neutrals.echoLightO[1300],
        1: neutrals.echoLightO[1200],
        2: neutrals.echoLightO[700],
        3: neutrals.echoLightO[50],
      },
      on: {
        color: {
          dark: {
            dark: neutrals.duskwraithO[1000],
            light: neutrals.duskwraithO[1000],
          },
          light: {
            dark: neutrals.echoLightO[1000],
            light: neutrals.echoLightO[1000],
          },
        },
      },
      inverse: {
        base: neutrals.grayBlueO[700],
        1: neutrals.grayBlueO[600],
        2: neutrals.grayBlueO[300],
        3: neutrals.grayBlueO[50],
      },
      brand: {
        base: color.blue.brandPrimaryO[600],
        1: color.blue.brandPrimaryO[500],
        2: color.blue.brandPrimaryO[300],
        3: color.blue.brandPrimaryO[50],
      },
      code: {
        punctuation: {
          base: special.code1[200],
          1: special.code1[300],
          2: {
            base: special.code1[200],
            1: special.code1[300],
            2: special.code1[400],
            3: special.code1[500],
          },
          3: special.code1[500],
        },
        constant: {
          base: special.code2[200],
          1: special.code2[300],
          2: {
            base: special.code2[200],
            1: special.code2[300],
            2: special.code2[400],
            3: special.code2[500],
          },
          3: special.code2[500],
        },
        entity: {
          base: special.code3[200],
          1: special.code3[300],
          2: {
            base: special.code3[200],
            1: special.code3[300],
            2: special.code3[400],
            3: special.code3[500],
          },
          3: special.code3[500],
          other: {
            inheritedClass: {
              base: special.code12[200],
              1: special.code12[300],
              2: {
                base: special.code12[200],
                1: special.code12[300],
                2: special.code12[400],
                3: special.code12[500],
              },
              3: special.code12[500],
            },
          },
        },
        keyword: {
          base: special.code4[200],
          1: special.code4[300],
          2: {
            base: special.code4[200],
            1: special.code4[300],
            2: special.code4[400],
            3: special.code4[500],
          },
          3: special.code4[500],
        },
        storage: {
          base: special.code5[200],
          1: special.code5[300],
          2: {
            base: special.code5[200],
            1: special.code5[300],
            2: special.code5[400],
            3: special.code5[500],
          },
          3: special.code5[500],
        },
        unquoted: {
          oldplist: {
            base: special.code6[200],
            1: special.code6[300],
            2: {
              base: special.code6[200],
              1: special.code6[300],
              2: special.code6[400],
              3: special.code6[500],
            },
            3: special.code6[500],
          },
        },
        comment: {
          base: special.code7[200],
          1: special.code7[300],
          2: {
            base: special.code7[200],
            1: special.code7[300],
            2: special.code7[400],
            3: special.code7[500],
          },
          3: special.code7[500],
        },
        support: {
          base: special.code8[200],
          1: special.code8[300],
          2: {
            base: special.code8[200],
            1: special.code8[300],
            2: special.code8[400],
            3: special.code8[500],
          },
          3: special.code8[500],
          function: {
            base: special.code17[200],
            1: special.code17[300],
            2: {
              base: special.code17[200],
              1: special.code17[300],
              2: special.code17[400],
              3: special.code17[500],
            },
            3: special.code17[500],
          },
          constant: {
            base: special.code18[200],
            1: special.code18[300],
            2: {
              base: special.code18[200],
              1: special.code18[300],
              2: special.code18[400],
              3: special.code18[500],
            },
            3: special.code18[500],
          },
          type: {
            exception: {
              base: special.code19[200],
              1: special.code19[300],
              2: {
                base: special.code19[200],
                1: special.code19[300],
                2: special.code19[400],
                3: special.code19[500],
              },
              3: special.code19[500],
            },
            propertyName: {
              base: special.code26[200],
              1: special.code26[300],
              2: {
                base: special.code26[200],
                1: special.code26[300],
                2: special.code26[400],
                3: special.code26[500],
              },
              3: special.code26[500],
            },
          },
        },
        variable: {
          base: special.code9[200],
          1: special.code9[300],
          2: {
            base: special.code9[200],
            1: special.code9[300],
            2: special.code9[400],
            3: special.code9[500],
          },
          3: special.code9[500],
          language: {
            base: special.code10[200],
            1: special.code10[300],
            2: {
              base: special.code10[200],
              1: special.code10[300],
              2: special.code10[400],
              3: special.code10[500],
            },
            3: special.code10[500],
          },
        },
        escape: {
          invalid: {
            base: special.code11[200],
            1: special.code11[300],
            2: {
              base: special.code11[200],
              1: special.code11[300],
              2: special.code11[400],
              3: special.code11[500],
            },
            3: special.code11[500],
          },
        },
        quoted: {
          source: {
            base: special.code13[200],
            1: special.code13[300],
            2: {
              base: special.code13[200],
              1: special.code13[300],
              2: special.code13[400],
              3: special.code13[500],
            },
            3: special.code13[500],
          },
        },
        string: {
          constant: {
            base: special.code14[200],
            1: special.code14[300],
            2: {
              base: special.code14[200],
              1: special.code14[300],
              2: special.code14[400],
              3: special.code14[500],
            },
            3: special.code14[500],
          },
          regexp: {
            base: special.code15[200],
            1: special.code15[300],
            2: {
              base: special.code15[200],
              1: special.code15[300],
              2: special.code15[400],
              3: special.code15[500],
            },
            3: special.code15[500],
          },
          variable: {
            base: special.code16[200],
            1: special.code16[300],
            2: {
              base: special.code16[200],
              1: special.code16[300],
              2: special.code16[400],
              3: special.code16[500],
            },
            3: special.code16[500],
          },
        },
        meta: {
          preprocessor: {
            c: {
              base: special.code20[200],
              1: special.code20[300],
              2: {
                base: special.code20[200],
                1: special.code20[300],
                2: special.code20[400],
                3: special.code20[500],
              },
              3: special.code20[500],
              keyword: {
                base: special.code21[200],
                1: special.code21[300],
                2: {
                  base: special.code21[200],
                  1: special.code21[300],
                  2: special.code21[400],
                  3: special.code21[500],
                },
                3: special.code21[500],
              },
            },
          },
          sgmlhtml: {
            meta: {
              doctype: {
                base: special.code22[200],
                1: special.code22[300],
                2: {
                  base: special.code22[200],
                  1: special.code22[300],
                  2: special.code22[400],
                  3: special.code22[500],
                },
                3: special.code22[500],
              },
            },
          },
          tag: {
            base: special.code23[200],
            1: special.code23[300],
            2: {
              base: special.code23[200],
              1: special.code23[300],
              2: special.code23[400],
              3: special.code23[500],
            },
            3: special.code23[500],
          },
          attributeName: {
            id: {
              base: special.code24[200],
              1: special.code24[300],
              2: {
                base: special.code24[200],
                1: special.code24[300],
                2: special.code24[400],
                3: special.code24[500],
              },
              3: special.code24[500],
            },
            class: {
              base: special.code25[200],
              1: special.code25[300],
              2: {
                base: special.code25[200],
                1: special.code25[300],
                2: special.code25[400],
                3: special.code25[500],
              },
              3: special.code25[500],
            },
          },
          propertyValue: {
            css: {
              base: special.code27[200],
              1: special.code27[300],
              2: {
                base: special.code27[200],
                1: special.code27[300],
                2: special.code27[400],
                3: special.code27[500],
              },
              3: special.code27[500],
            },
          },
          control: {
            atRule: {
              base: special.code28[200],
              1: special.code28[300],
              2: {
                base: special.code28[200],
                1: special.code28[300],
                2: special.code28[400],
                3: special.code28[500],
              },
              3: special.code28[500],
            },
          },
          namedColor: {
            css: {
              2: {
                base: special.code29[200],
                1: special.code29[300],
                2: special.code29[400],
                3: special.code29[500],
              },
              3: {
                base: special.code29[200],
                1: special.code29[300],
                2: special.code29[400],
                3: special.code29[500],
              },
            },
          },
        },
        markup: {
          bold: {
            base: special.code30[200],
            1: special.code30[300],
            2: {
              base: special.code30[200],
              1: special.code30[300],
              2: special.code30[400],
              3: special.code30[500],
            },
            3: special.code30[500],
          },
          italic: {
            base: special.code31[200],
            1: special.code31[300],
            2: {
              base: special.code31[200],
              1: special.code31[300],
              2: special.code31[400],
              3: special.code31[500],
            },
            3: special.code31[500],
          },
          heading: {
            base: special.code32[200],
            1: special.code32[300],
            2: {
              base: special.code32[200],
              1: special.code32[300],
              2: special.code32[400],
              3: special.code32[500],
            },
            3: special.code32[500],
          },
        },
        light: {
          light: {
            punctuation: {
              base: special.code1[200],
              1: special.code1[300],
              2: special.code1[400],
              3: special.code1[500],
            },
            constant: {
              base: special.code2[200],
              1: special.code2[300],
              2: special.code2[400],
              3: special.code2[500],
            },
            entity: {
              base: special.code3[200],
              1: special.code3[300],
              2: special.code3[400],
              3: special.code3[500],
              other: {
                inheritedClass: {
                  base: special.code12[200],
                  1: special.code12[300],
                  2: special.code12[400],
                  3: special.code12[500],
                },
              },
            },
            keyword: {
              base: special.code4[200],
              1: special.code4[300],
              2: special.code4[400],
              3: special.code4[500],
            },
            storage: {
              base: special.code5[200],
              1: special.code5[300],
              2: special.code5[400],
              3: special.code5[500],
            },
            unquoted: {
              oldplist: {
                base: special.code6[200],
                1: special.code6[300],
                2: special.code6[400],
                3: special.code6[500],
              },
            },
            comment: {
              base: special.code7[200],
              1: special.code7[300],
              2: special.code7[400],
              3: special.code7[500],
            },
            support: {
              base: special.code8[200],
              1: special.code8[300],
              2: special.code8[400],
              3: special.code8[500],
              function: {
                base: special.code17[200],
                1: special.code17[300],
                2: special.code17[400],
                3: special.code17[500],
              },
              constant: {
                base: special.code18[200],
                1: special.code18[300],
                2: special.code18[400],
                3: special.code18[500],
              },
              type: {
                exception: {
                  base: special.code19[200],
                  1: special.code19[300],
                  2: special.code19[400],
                  3: special.code19[500],
                },
                propertyName: {
                  base: special.code26[200],
                  1: special.code26[300],
                  2: special.code26[400],
                  3: special.code26[500],
                },
              },
            },
            variable: {
              base: special.code9[200],
              1: special.code9[300],
              2: special.code9[400],
              3: special.code9[500],
              language: {
                base: special.code10[200],
                1: special.code10[300],
                2: special.code10[400],
                3: special.code10[500],
              },
            },
            escape: {
              invalid: {
                base: special.code11[200],
                1: special.code11[300],
                2: special.code11[400],
                3: special.code11[500],
              },
            },
            quoted: {
              source: {
                base: special.code13[200],
                1: special.code13[300],
                2: special.code13[400],
                3: special.code13[500],
              },
            },
            string: {
              constant: {
                base: special.code14[200],
                1: special.code14[300],
                2: special.code14[400],
                3: special.code14[500],
              },
              regexp: {
                base: special.code15[200],
                1: special.code15[300],
                2: special.code15[400],
                3: special.code15[500],
              },
              variable: {
                base: special.code16[200],
                1: special.code16[300],
                2: special.code16[400],
                3: special.code16[500],
              },
            },
            meta: {
              preprocessor: {
                c: {
                  base: special.code20[200],
                  1: special.code20[300],
                  2: special.code20[400],
                  3: special.code20[500],
                  keyword: {
                    base: special.code21[200],
                    1: special.code21[300],
                    2: special.code21[400],
                    3: special.code21[500],
                  },
                },
              },
              sgmlhtml: {
                meta: {
                  doctype: {
                    base: special.code22[200],
                    1: special.code22[300],
                    2: special.code22[400],
                    3: special.code22[500],
                  },
                },
              },
              tag: {
                base: special.code23[200],
                1: special.code23[300],
                2: special.code23[400],
                3: special.code23[500],
              },
              attributeName: {
                id: {
                  base: special.code24[200],
                  1: special.code24[300],
                  2: special.code24[400],
                  3: special.code24[500],
                },
                class: {
                  base: special.code25[200],
                  1: special.code25[300],
                  2: special.code25[400],
                  3: special.code25[500],
                },
              },
              propertyValue: {
                css: {
                  base: special.code27[200],
                  1: special.code27[300],
                  2: special.code27[400],
                  3: special.code27[500],
                },
              },
              control: {
                atRule: {
                  base: special.code28[200],
                  1: special.code28[300],
                  2: special.code28[400],
                  3: special.code28[500],
                },
              },
              namedColor: {
                css: {
                  2: {
                    base: special.code29[200],
                    1: special.code29[300],
                    2: special.code29[400],
                    3: special.code29[500],
                  },
                },
              },
            },
            markup: {
              bold: {
                base: special.code30[200],
                1: special.code30[300],
                2: special.code30[400],
                3: special.code30[500],
              },
              italic: {
                base: special.code31[200],
                1: special.code31[300],
                2: special.code31[400],
                3: special.code31[500],
              },
              heading: {
                base: special.code32[200],
                1: special.code32[300],
                2: special.code32[400],
                3: special.code32[500],
              },
            },
          },
        },
      },
      semantic: {
        success: {
          base: color.green.limegreenO[700],
          1: color.green.limegreenO[600],
          2: {
            base: color.green.limegreenO[700],
            1: color.green.limegreenO[600],
            2: color.green.limegreenO[300],
            3: color.green.limegreenO[50],
          },
          3: color.green.limegreenO[50],
        },
        warning: {
          base: color.orange.burntSiennaO[700],
          1: color.orange.burntSiennaO[600],
          2: {
            base: color.orange.burntSiennaO[700],
            1: color.orange.burntSiennaO[600],
            2: color.orange.burntSiennaO[300],
            3: color.orange.burntSiennaO[50],
          },
          3: color.orange.burntSiennaO[50],
        },
        error: {
          base: color.red.crimsonO[500],
          1: color.red.crimsonO[400],
          2: {
            base: color.red.crimsonO[500],
            1: color.red.crimsonO[400],
            2: color.red.crimsonO[200],
            3: color.red.crimsonO[50],
          },
          3: color.red.crimsonO[50],
        },
        info: {
          base: color.blue.skyblueO[600],
          1: color.blue.skyblueO[500],
          2: {
            base: color.blue.skyblueO[600],
            1: color.blue.skyblueO[500],
            2: color.blue.skyblueO[300],
            3: color.blue.skyblueO[50],
          },
          3: color.blue.skyblueO[50],
        },
        suggest: {
          base: color.yellow.eggshellO[700],
          1: color.yellow.eggshellO[600],
          2: {
            base: color.yellow.eggshellO[700],
            1: color.yellow.eggshellO[600],
            2: color.yellow.eggshellO[300],
            3: color.yellow.eggshellO[50],
          },
          3: color.yellow.eggshellO[50],
        },
        light: {
          light: {
            success: {
              base: color.green.limegreenO[700],
              1: color.green.limegreenO[600],
              2: color.green.limegreenO[300],
              3: color.green.limegreenO[50],
            },
            warning: {
              base: color.orange.burntSiennaO[700],
              1: color.orange.burntSiennaO[600],
              2: color.orange.burntSiennaO[300],
              3: color.orange.burntSiennaO[50],
            },
            error: {
              base: color.red.crimsonO[500],
              1: color.red.crimsonO[400],
              2: color.red.crimsonO[200],
              3: color.red.crimsonO[50],
            },
            info: {
              base: color.blue.skyblueO[600],
              1: color.blue.skyblueO[500],
              2: color.blue.skyblueO[300],
              3: color.blue.skyblueO[50],
            },
            suggest: {
              base: color.yellow.eggshellO[700],
              1: color.yellow.eggshellO[600],
              2: color.yellow.eggshellO[300],
              3: color.yellow.eggshellO[50],
            },
          },
        },
      },
      accent: {
        1: {
          base: color.blue.lightO[950],
          1: color.blue.lightO[900],
          2: color.blue.lightO[700],
          3: color.blue.lightO[600],
        },
        2: {
          base: color.purple.violetO[600],
          1: color.purple.violetO[500],
          2: color.purple.violetO[300],
          3: color.purple.violetO[200],
        },
        3: {
          base: color.teal.sunsparkOasisO[1200],
          1: color.teal.sunsparkOasisO[1100],
          2: color.teal.sunsparkOasisO[600],
          3: color.teal.sunsparkOasisO[500],
        },
        4: {
          base: color.orange.sunstreakO[1100],
          1: color.orange.sunstreakO[1000],
          2: color.orange.sunstreakO[600],
          3: color.orange.sunstreakO[400],
        },
        8: {
          base: color.purple.deepPurpO[800],
          1: color.purple.deepPurpO[700],
          2: color.purple.deepPurpO[600],
          3: color.purple.deepPurpO[400],
        },
        14: {
          base: color.blue.neptuneO[1300],
          1: color.blue.neptuneO[1200],
          2: color.blue.neptuneO[1000],
          3: color.blue.neptuneO[800],
        },
        15: {
          base: color.green.emeraldSaberO[1100],
          1: color.green.emeraldSaberO[950],
          2: color.green.emeraldSaberO[800],
          3: color.green.emeraldSaberO[500],
        },
        16: {
          base: color.blue.neptuneO[900],
          1: color.blue.neptuneO[800],
          2: color.blue.neptuneO[600],
          3: color.blue.neptuneO[500],
        },
        light: {
          light: {
            1: {
              base: color.blue.lightO[950],
              1: color.blue.lightO[900],
              2: color.blue.lightO[700],
              3: color.blue.lightO[600],
            },
            2: {
              base: color.purple.violetO[600],
              1: color.purple.violetO[500],
              2: color.purple.violetO[300],
              3: color.purple.violetO[200],
            },
            3: {
              base: color.teal.sunsparkOasisO[1200],
              1: color.teal.sunsparkOasisO[1100],
              2: color.teal.sunsparkOasisO[600],
              3: color.teal.sunsparkOasisO[500],
            },
            4: {
              base: color.orange.sunstreakO[1100],
              1: color.orange.sunstreakO[1000],
              2: color.orange.sunstreakO[600],
              3: color.orange.sunstreakO[400],
            },
            8: {
              base: color.purple.deepPurpO[800],
              1: color.purple.deepPurpO[700],
              2: color.purple.deepPurpO[600],
              3: color.purple.deepPurpO[400],
            },
            14: {
              base: color.blue.neptuneO[1300],
              1: color.blue.neptuneO[1200],
              2: color.blue.neptuneO[1000],
              3: color.blue.neptuneO[800],
            },
            15: {
              base: color.green.emeraldSaberO[1100],
              1: color.green.emeraldSaberO[950],
              2: color.green.emeraldSaberO[800],
              3: color.green.emeraldSaberO[500],
            },
            16: {
              base: color.blue.neptuneO[900],
              1: color.blue.neptuneO[800],
              2: color.blue.neptuneO[600],
              3: color.blue.neptuneO[500],
            },
          },
        },
      },
    },
    assets: {
      basic: {
        clear: neutrals.clear,
        black: neutrals.duskwraithA[1000],
        white: neutrals.pureWhite[1000],
      },
      neutral: {
        base: neutrals.echoLightO[1300],
        1: neutrals.echoLightO[1200],
        2: neutrals.echoLightO[700],
        3: neutrals.echoLightO[50],
      },
      on: {
        color: {
          dark: {
            dark: neutrals.duskwraithO[1000],
            light: neutrals.duskwraithO[1000],
          },
          light: {
            dark: neutrals.echoLightO[1000],
            light: neutrals.echoLightO[1000],
          },
        },
      },
      inverse: {
        base: neutrals.duskwraithO[600],
        1: neutrals.duskwraithO[500],
        2: neutrals.duskwraithO[300],
        3: neutrals.duskwraithO[50],
      },
      brand: {
        base: color.blue.brandPrimaryO[600],
        1: color.blue.brandPrimaryO[500],
        2: color.blue.brandPrimaryO[300],
        3: color.blue.brandPrimaryO[50],
      },
      secondary: {
        base: color.blue.secondaryBlueO[700],
        1: color.blue.secondaryBlueO[600],
        2: color.blue.secondaryBlueO[300],
        3: color.blue.secondaryBlueO[50],
      },
      semantic: {
        success: {
          base: color.green.limegreenO[300],
          1: color.green.limegreenO[400],
          2: color.green.limegreenO[500],
          3: color.green.limegreenO[600],
        },
        warning: {
          base: color.orange.burntSiennaO[300],
          1: color.orange.burntSiennaO[400],
          2: color.orange.burntSiennaO[500],
          3: color.orange.burntSiennaO[600],
        },
        error: {
          base: color.red.crimsonO[300],
          1: color.red.crimsonO[400],
          2: color.red.crimsonO[500],
          3: color.red.crimsonO[600],
        },
        info: {
          base: color.blue.skyblueO[300],
          1: color.blue.skyblueO[400],
          2: color.blue.skyblueO[500],
          3: color.blue.skyblueO[600],
        },
        suggest: {
          base: color.yellow.eggshellO[300],
          1: color.yellow.eggshellO[400],
          2: color.yellow.eggshellO[500],
          3: color.yellow.eggshellO[600],
        },
      },
      accent: {
        1: {
          base: color.blue.lightO[600],
          1: color.blue.lightO[700],
          2: color.blue.lightO[800],
          3: color.blue.lightO[900],
        },
        2: {
          base: color.purple.violetO[300],
          1: color.purple.violetO[400],
          2: color.purple.violetO[500],
          3: color.purple.violetO[600],
        },
        3: {
          base: color.teal.sunsparkOasisO[600],
          1: color.teal.sunsparkOasisO[700],
          2: color.teal.sunsparkOasisO[900],
          3: color.teal.sunsparkOasisO[1200],
        },
        4: {
          base: color.orange.sunstreakO[500],
          1: color.orange.sunstreakO[600],
          2: color.orange.sunstreakO[900],
          3: color.orange.sunstreakO[1100],
        },
        5: {
          base: color.yellow.twinSunlightO[400],
          1: color.yellow.twinSunlightO[500],
          2: color.yellow.twinSunlightO[700],
          3: color.yellow.twinSunlightO[950],
        },
        6: {
          base: color.blue.electricBlueO[500],
          1: color.blue.electricBlueO[700],
          2: color.blue.electricBlueO[900],
          3: color.blue.electricBlueO[1000],
        },
        7: {
          base: color.orange.amberO[600],
          1: color.orange.amberO[800],
          2: color.orange.amberO[950],
          3: color.orange.amberO[1000],
        },
        8: {
          base: color.purple.deepPurpO[500],
          1: color.purple.deepPurpO[700],
          2: color.purple.deepPurpO[900],
          3: color.purple.deepPurpO[1000],
        },
        9: {
          base: color.magenta.magentaO[500],
          1: color.magenta.magentaO[600],
          2: color.magenta.magentaO[900],
          3: color.magenta.magentaO[1000],
        },
        10: {
          base: color.green.forestO[400],
          1: color.green.forestO[600],
          2: color.green.forestO[900],
          3: color.green.forestO[1000],
        },
        11: {
          base: color.orange.pumpkinO[500],
          1: color.orange.pumpkinO[600],
          2: color.orange.pumpkinO[900],
          3: color.orange.pumpkinO[1100],
        },
        12: {
          base: color.yellow.sunnyO[500],
          1: color.yellow.sunnyO[700],
          2: color.yellow.sunnyO[950],
          3: color.yellow.sunnyO[1100],
        },
        13: {
          base: color.teal.mintyO[400],
          1: color.teal.mintyO[500],
          2: color.teal.mintyO[700],
          3: color.teal.mintyO[900],
        },
        14: {
          base: color.blue.neptuneO[600],
          1: color.blue.neptuneO[800],
          2: color.blue.neptuneO[1100],
          3: color.blue.neptuneO[1300],
        },
        15: {
          base: color.green.emeraldSaberO[500],
          1: color.green.emeraldSaberO[800],
          2: color.green.emeraldSaberO[950],
          3: color.green.emeraldSaberO[1100],
        },
        16: {
          base: color.blue.neptuneO[500],
          1: color.blue.neptuneO[700],
          2: color.blue.neptuneO[900],
          3: color.blue.neptuneO[1100],
        },
      },
    },
  },
  stroke: {
    basic: {
      clear: neutrals.clear,
      black: neutrals.duskwraithA[1000],
      white: neutrals.pureWhite[1000],
    },
    neutral: {
      base: neutrals.echoLightA[1000],
      1: neutrals.echoLightA[700],
      2: neutrals.echoLightA[600],
      3: neutrals.echoLightA[500],
      4: neutrals.echoLightA[400],
      5: neutrals.echoLightA[200],
      6: neutrals.echoLightA[100],
      raised: {
        base: neutrals.echoLightA[1000],
        1: neutrals.echoLightA[900],
        2: neutrals.echoLightA[600],
        3: neutrals.echoLightA[400],
        4: neutrals.echoLightA[300],
        5: neutrals.echoLightA[100],
        6: neutrals.echoLightA[50],
        7: neutrals.echoLightA[50],
      },
      inverse: {
        raised: {
          base: neutrals.duskwraithA[1000],
          1: neutrals.duskwraithA[900],
          2: neutrals.duskwraithA[700],
          3: neutrals.duskwraithA[500],
          4: neutrals.duskwraithA[300],
          5: neutrals.duskwraithA[200],
          6: neutrals.duskwraithA[50],
        },
        raisedToBrand: {
          base: neutrals.duskwraithA[1000],
          1: neutrals.duskwraithA[900],
          2: neutrals.duskwraithA[700],
          3: neutrals.duskwraithA[500],
          4: neutrals.duskwraithA[300],
          5: neutrals.duskwraithA[200],
          6: neutrals.duskwraithA[50],
        },
      },
      mid: {
        base: neutrals.grayBlueA[1000],
        1: neutrals.grayBlueA[900],
        2: neutrals.grayBlueA[600],
        3: neutrals.grayBlueA[400],
        4: neutrals.grayBlueA[300],
        5: neutrals.grayBlueA[100],
        6: neutrals.grayBlueA[50],
      },
      midToBrand: {
        base: neutrals.grayBlueA[1000],
        1: neutrals.grayBlueA[900],
        2: neutrals.grayBlueA[600],
        3: neutrals.grayBlueA[400],
        4: neutrals.grayBlueA[300],
        5: neutrals.grayBlueA[100],
        6: neutrals.grayBlueA[50],
      },
      midToWhite: {
        base: neutrals.grayBlueA[1000],
        1: neutrals.grayBlueA[900],
        2: neutrals.grayBlueA[600],
        3: neutrals.grayBlueA[400],
        4: neutrals.grayBlueA[300],
        5: neutrals.grayBlueA[100],
        6: neutrals.grayBlueA[50],
      },
    },
    brand: {
      base: color.blue.brandPrimaryA[1000],
      1: color.blue.brandPrimaryA[900],
      2: color.blue.brandPrimaryA[800],
      3: color.blue.brandPrimaryA[500],
      4: color.blue.brandPrimaryA[200],
      5: color.blue.brandPrimaryA[100],
    },
    semantic: {
      success: {
        base: color.green.ionSproutA[1000],
        1: color.green.ionSproutA[900],
        2: color.green.ionSproutA[800],
        3: color.green.ionSproutA[500],
        4: color.green.ionSproutA[200],
        5: color.green.ionSproutA[100],
      },
      warning: {
        base: color.orange.warmA[1000],
        1: color.orange.warmA[900],
        2: color.orange.warmA[800],
        3: color.orange.warmA[500],
        4: color.orange.warmA[200],
        5: color.orange.warmA[100],
      },
      error: {
        base: color.red.malachorA[1000],
        1: color.red.malachorA[900],
        2: color.red.malachorA[800],
        3: color.red.malachorA[500],
        4: color.red.malachorA[400],
        5: color.red.malachorA[100],
      },
      info: {
        base: color.blue.skyboltA[1000],
        1: color.blue.skyboltA[900],
        2: color.blue.skyboltA[800],
        3: color.blue.skyboltA[500],
        4: color.blue.skyboltA[200],
        5: color.blue.skyboltA[100],
      },
      suggest: {
        base: color.yellow.sunnyA[1000],
        1: color.yellow.sunnyA[900],
        2: color.yellow.sunnyA[800],
        3: color.yellow.sunnyA[500],
        4: color.yellow.sunnyA[200],
        5: color.yellow.sunnyA[100],
      },
    },
    focused: {
      highlight: color.blue.brandPrimaryA[500],
    },
    accent: {
      1: {
        base: color.blue.lightA[1000],
        1: color.blue.lightA[800],
        2: color.blue.lightA[700],
        3: color.blue.lightA[500],
        4: color.blue.lightA[400],
        5: color.blue.lightA[100],
      },
      2: {
        base: color.purple.violetA[1000],
        1: color.purple.violetA[900],
        2: color.purple.violetA[800],
        3: color.purple.violetA[500],
        4: color.purple.violetA[200],
        5: color.purple.violetA[100],
      },
      3: {
        base: color.teal.sunsparkOasisA[1000],
        1: color.teal.sunsparkOasisA[900],
        2: color.teal.sunsparkOasisA[800],
        3: color.teal.sunsparkOasisA[500],
        4: color.teal.sunsparkOasisA[200],
        5: color.teal.sunsparkOasisA[100],
      },
      4: {
        base: color.orange.sunstreakA[1000],
        1: color.orange.sunstreakA[900],
        2: color.orange.sunstreakA[800],
        3: color.orange.sunstreakA[500],
        4: color.orange.sunstreakA[200],
        5: color.orange.sunstreakA[100],
      },
      5: {
        base: color.yellow.twinSunlightA[1000],
        1: color.yellow.twinSunlightA[900],
        2: color.yellow.twinSunlightA[800],
        3: color.yellow.twinSunlightA[500],
        4: color.yellow.twinSunlightA[200],
        5: color.yellow.twinSunlightA[100],
      },
      6: {
        base: color.blue.electricBlueA[1000],
        1: color.blue.electricBlueA[900],
        2: color.blue.electricBlueA[800],
        3: color.blue.electricBlueA[500],
        4: color.blue.electricBlueA[200],
        5: color.blue.electricBlueA[100],
      },
      7: {
        base: color.orange.amberA[1000],
        1: color.orange.amberA[900],
        2: color.orange.amberA[800],
        3: color.orange.amberA[500],
        4: color.orange.amberA[200],
        5: color.orange.amberA[100],
      },
      8: {
        base: color.purple.deepPurpA[1000],
        1: color.purple.deepPurpA[900],
        2: color.purple.deepPurpA[800],
        3: color.purple.deepPurpA[500],
        4: color.purple.deepPurpA[200],
        5: color.purple.deepPurpA[100],
      },
      9: {
        base: color.magenta.magentaA[1000],
        1: color.magenta.magentaA[900],
        2: color.magenta.magentaA[800],
        3: color.magenta.magentaA[500],
        4: color.magenta.magentaA[200],
        5: color.magenta.magentaA[100],
      },
      10: {
        base: color.green.forestA[1000],
        1: color.green.forestA[900],
        2: color.green.forestA[800],
        3: color.green.forestA[500],
        4: color.green.forestA[200],
        5: color.green.forestA[100],
      },
      11: {
        base: color.orange.pumpkinA[1000],
        1: color.orange.pumpkinA[900],
        2: color.orange.pumpkinA[800],
        3: color.orange.pumpkinA[500],
        4: color.orange.pumpkinA[200],
        5: color.orange.pumpkinA[100],
      },
      12: {
        base: color.yellow.sunnyA[1000],
        1: color.yellow.sunnyA[900],
        2: color.yellow.sunnyA[800],
        3: color.yellow.sunnyA[500],
        4: color.yellow.sunnyA[200],
        5: color.yellow.sunnyA[100],
      },
      13: {
        base: color.teal.mintyA[1000],
        1: color.teal.mintyA[900],
        2: color.teal.mintyA[800],
        3: color.teal.mintyA[500],
        4: color.teal.mintyA[200],
        5: color.teal.mintyA[100],
      },
      14: {
        base: color.blue.neptuneA[1000],
        1: color.blue.neptuneA[900],
        2: color.blue.neptuneA[800],
        3: color.blue.neptuneA[500],
        4: color.blue.neptuneA[200],
        5: color.blue.neptuneA[100],
      },
      15: {
        base: color.green.emeraldSaberA[1000],
        1: color.green.emeraldSaberA[900],
        2: color.green.emeraldSaberA[800],
        3: color.green.emeraldSaberA[500],
        4: color.green.emeraldSaberA[200],
        5: color.green.emeraldSaberA[100],
      },
      16: {
        base: color.blue.neptuneA[1000],
        1: color.blue.neptuneA[900],
        2: color.blue.neptuneA[800],
        3: color.blue.neptuneA[500],
        4: color.blue.neptuneA[200],
        5: color.blue.neptuneA[100],
      },
    },
  },
  strokeO: {
    basic: {
      clear: neutrals.clear,
      black: neutrals.duskwraithA[1000],
      white: neutrals.pureWhite[1000],
    },
    neutral: {
      base: neutrals.duskwraithO[200],
      1: neutrals.duskwraithO[300],
      2: neutrals.duskwraithO[400],
      3: neutrals.duskwraithO[500],
      mid: {
        base: neutrals.grayBlueO[600],
        1: neutrals.grayBlueO[700],
        2: neutrals.grayBlueO[800],
        3: neutrals.grayBlueO[900],
      },
      midToBrand: {
        base: color.blue.brandPrimaryO[500],
        1: color.blue.brandPrimaryO[600],
        2: color.blue.brandPrimaryO[700],
        3: color.blue.brandPrimaryO[800],
      },
      midToWhite: {
        base: neutrals.grayBlueO[300],
        1: neutrals.grayBlueO[400],
        2: neutrals.grayBlueO[500],
        3: neutrals.grayBlueO[600],
      },
    },
    brand: {
      base: color.blue.brandPrimaryO[400],
      1: color.blue.brandPrimaryO[500],
      2: color.blue.brandPrimaryO[600],
      3: color.blue.brandPrimaryO[700],
      4: color.blue.brandPrimaryO[800],
      5: color.blue.brandPrimaryO[900],
    },
    semantic: {
      success: {
        base: color.green.ionSproutO[600],
        1: color.green.ionSproutO[700],
        2: color.green.ionSproutO[800],
        3: color.green.ionSproutO[900],
        4: color.green.ionSproutO[1000],
        5: color.green.ionSproutO[1100],
      },
      warning: {
        base: color.orange.warmO[700],
        1: color.orange.warmO[800],
        2: color.orange.warmO[900],
        3: color.orange.warmO[950],
        4: color.orange.warmO[1000],
        5: color.orange.warmO[1100],
      },
      error: {
        base: color.red.malachorO[700],
        1: color.red.malachorO[800],
        2: color.red.malachorO[900],
        3: color.red.malachorO[950],
        4: color.red.malachorO[1000],
        5: color.red.malachorO[1100],
      },
      info: {
        base: color.blue.skyboltO[600],
        1: color.blue.skyboltO[700],
        2: color.blue.skyboltO[800],
        3: color.blue.skyboltO[900],
        4: color.blue.skyboltO[1000],
        5: color.blue.skyboltO[1100],
      },
      suggest: {
        base: color.yellow.sunnyO[700],
        1: color.yellow.sunnyO[800],
        2: color.yellow.sunnyO[900],
        3: color.yellow.sunnyO[950],
        4: color.yellow.sunnyO[1000],
        5: color.yellow.sunnyO[1100],
      },
    },
    focused: {
      highlight: color.blue.brandPrimaryO[500],
    },
    accent: {
      1: {
        base: color.blue.lightO[600],
        1: color.blue.lightO[700],
        2: color.blue.lightO[800],
        3: color.blue.lightO[900],
        4: color.blue.lightO[1000],
        5: color.blue.lightO[1100],
      },
      2: {
        base: color.purple.violetO[600],
        1: color.purple.violetO[700],
        2: color.purple.violetO[800],
        3: color.purple.violetO[900],
        4: color.purple.violetO[1000],
        5: color.purple.violetO[1100],
      },
      3: {
        base: color.teal.sunsparkOasisO[600],
        1: color.teal.sunsparkOasisO[700],
        2: color.teal.sunsparkOasisO[800],
        3: color.teal.sunsparkOasisO[900],
        4: color.teal.sunsparkOasisO[1000],
        5: color.teal.sunsparkOasisO[1100],
      },
      4: {
        base: color.orange.sunstreakO[600],
        1: color.orange.sunstreakO[700],
        2: color.orange.sunstreakO[800],
        3: color.orange.sunstreakO[900],
        4: color.orange.sunstreakO[1000],
        5: color.orange.sunstreakO[1100],
      },
      5: {
        base: color.yellow.twinSunlightO[600],
        1: color.yellow.twinSunlightO[700],
        2: color.yellow.twinSunlightO[800],
        3: color.yellow.twinSunlightO[900],
        4: color.yellow.twinSunlightO[1000],
        5: color.yellow.twinSunlightO[1100],
      },
      6: {
        base: color.blue.electricBlueO[600],
        1: color.blue.electricBlueO[700],
        2: color.blue.electricBlueO[800],
        3: color.blue.electricBlueO[900],
        4: color.blue.electricBlueO[1000],
        5: color.blue.electricBlueO[1100],
      },
      7: {
        base: color.orange.amberO[600],
        1: color.orange.amberO[700],
        2: color.orange.amberO[800],
        3: color.orange.amberO[900],
        4: color.orange.amberO[1000],
        5: color.orange.amberO[1100],
      },
      8: {
        base: color.purple.deepPurpO[600],
        1: color.purple.deepPurpO[700],
        2: color.purple.deepPurpO[800],
        3: color.purple.deepPurpO[900],
        4: color.purple.deepPurpO[1000],
        5: color.purple.deepPurpO[1100],
      },
      9: {
        base: color.magenta.magentaO[600],
        1: color.magenta.magentaO[700],
        2: color.magenta.magentaO[800],
        3: color.magenta.magentaO[900],
        4: color.magenta.magentaO[1000],
        5: color.magenta.magentaO[1100],
      },
      10: {
        base: color.green.forestO[600],
        1: color.green.forestO[700],
        2: color.green.forestO[800],
        3: color.green.forestO[900],
        4: color.green.forestO[1000],
        5: color.green.forestO[1100],
      },
      11: {
        base: color.orange.pumpkinO[600],
        1: color.orange.pumpkinO[700],
        2: color.orange.pumpkinO[800],
        3: color.orange.pumpkinO[900],
        4: color.orange.pumpkinO[1000],
        5: color.orange.pumpkinO[1100],
      },
      12: {
        base: color.yellow.sunnyO[600],
        1: color.yellow.sunnyO[700],
        2: color.yellow.sunnyO[800],
        3: color.yellow.sunnyO[900],
        4: color.yellow.sunnyO[1000],
        5: color.yellow.sunnyO[1100],
      },
      13: {
        base: color.teal.mintyO[600],
        1: color.teal.mintyO[700],
        2: color.teal.mintyO[800],
        3: color.teal.mintyO[900],
        4: color.teal.mintyO[1000],
        5: color.teal.mintyO[1100],
      },
      14: {
        base: color.blue.neptuneO[600],
        1: color.blue.neptuneO[700],
        2: color.blue.neptuneO[800],
        3: color.blue.neptuneO[900],
        4: color.blue.neptuneO[1000],
        5: color.blue.neptuneO[1100],
      },
      15: {
        base: color.green.emeraldSaberO[600],
        1: color.green.emeraldSaberO[700],
        2: color.green.emeraldSaberO[800],
        3: color.green.emeraldSaberO[900],
        4: color.green.emeraldSaberO[1000],
        5: color.green.emeraldSaberO[1100],
      },
      16: {
        base: color.blue.neptuneO[600],
        1: color.blue.neptuneO[700],
        2: color.blue.neptuneO[800],
        3: color.blue.neptuneO[900],
        4: color.blue.neptuneO[1000],
        5: color.blue.neptuneO[1100],
      },
    },
  },
  effects: {
    focused: {
      base: color.blue.brandPrimaryA[1000],
      secondary: color.blue.lightA[600],
      success: color.teal.sunsparkOasisA[600],
      error: color.red.malachorA[600],
    },
    shadows: {
      base: {
        base: neutrals.duskwraithA[400],
        2: {
          xl: neutrals.duskwraithA[800],
        },
        xs: neutrals.duskwraithA[200],
        sm: neutrals.duskwraithA[300],
        md: neutrals.duskwraithA[500],
        lg: neutrals.duskwraithA[600],
        xl: neutrals.duskwraithA[700],
      },
      inverse: {
        base: neutrals.echoLightA[400],
        2: {
          xl: neutrals.echoLightA[800],
        },
        xs: neutrals.echoLightA[200],
        sm: neutrals.echoLightA[300],
        md: neutrals.echoLightA[500],
        lg: neutrals.echoLightA[600],
        xl: neutrals.echoLightA[700],
      },
    },
  },
  gradient: {
    neutral: {
      50: neutrals.echoLightA[50],
      100: neutrals.echoLightA[100],
      200: neutrals.echoLightA[200],
      300: neutrals.echoLightA[300],
      400: neutrals.echoLightA[400],
      500: neutrals.echoLightA[500],
      700: neutrals.echoLightA[700],
      1000: neutrals.echoLightA[1000],
    },
    brand: {
      50: color.blue.brandPrimaryA[50],
      100: color.blue.brandPrimaryA[100],
      200: color.blue.brandPrimaryA[200],
      300: color.blue.brandPrimaryA[300],
      400: color.blue.brandPrimaryA[400],
      500: color.blue.brandPrimaryA[500],
      600: color.blue.brandPrimaryA[600],
      700: color.blue.brandPrimaryA[700],
      800: color.blue.brandPrimaryA[800],
      1000: color.blue.brandPrimaryA[1000],
    },
  },

  /**
   * Chip family — two chip-specific palette stops that no other semantic
   * token in this file exposes. Everything else the chip needs is already in
   * t.backgroundO.*, t.strokeO.*, t.contentO.*; component-tokens.ts wires
   * those existing paths and pulls these two for the remaining cells.
   */
  chip: {
    // Static Filled error chip uses crimsonO[700] rather than the malachorO
    // ramp that `t.backgroundO.semantic.error` uses for non-chip surfaces.
    static: {
      errorFilledBackground: color.red.crimsonO[700], // #b02a31
    },
    // Cyan field-label color shared across every interactive chip cell.
    interactive: {
      fieldLabel: color.teal.cryoWakeA[1000], // #80fcff
    },
  },

  // TODO: old tokens, required to commit without breaking the code. remove after complete transfer to new token system
  // Text colors
  textPrimary: '#FEFEFE', // white-100
  textSecondary: '#86A3C3', // navyblue-100
  textDisabled: '#4F4F4F', // gray-600
  textInverse: '#333333', // gray-700
  // Primary colors
  primaryMain: '#0081C5', // blue-400
  primaryMainOpaque: '#0081C54D', // blue-400 with 30% opacity
  primaryLight: '#11A5F3', // blue-300
  primaryDark: '#0B5297', // blue-500
  // Secondary colors
  secondaryMain: '#14B597', // teal-400
  secondaryMainOpaque: '#14B5974D', // teal-400 with 30% opacity
  secondaryLight: '#35C6AB', // teal-300
  secondaryDark: '#09A084', // teal-500
  // Background colors
  backgroundPrimary: '#0F1623', // navyblue-800
  backgroundSecondary: '#192231', // navyblue-600
  backgroundTertiary: '#23344E', // navyblue-400
  backgroundPaper: '#141C2A', // navyblue-700
  backgroundDefault: '#0A0F1A', // navyblue-900
  // Surface colors
  surfaceLight: '#30415C', // navyblue-350
  surfaceLightOpaque: '#30415C4D', // navyblue-350 with 30% opacity
  surfaceMedium: '#1D2A3F', // navyblue-500
  surfaceDark: '#141C2A', // navyblue-700
  // Border colors
  borderPrimary: '#3E516B', // navyblue-300
  borderSecondary: '#4F627C', // navyblue-200
  borderLight: '#86A3C3', // navyblue-100
  // Input-specific colors (matching pounce Input components)
  inputBorderDefault: '#3E516B', // navyblue-300 - outline variant default border
  inputBorderHover: '#0081C5', // blue-400 - hover/focus border
  inputBorderInvalid: '#D64242', // red-300 - error state border
  inputBackgroundSolid: '#23344E', // navyblue-400 - solid variant background
  inputText: '#F6F6F6', // white-200 - input text color
  inputLabel: '#BDBDBD', // gray-300 - label and placeholder color
  inputLabelInvalid: '#D64242', // red-300 - invalid label color
  success: '#50931D', // green-500
  successLight: '#67B52C', // green-400
  successDark: '#25470C', // green-600
  warning: '#FFA500', // yellow-500
  warningLight: '#FFB41E', // yellow-400
  warningDark: '#E98702', // yellow-600
  error: '#AF0003', // red-500
  errorLight: '#C82727', // red-400
  errorDark: '#850003', // red-600
  info: '#0081C5', // blue-400
  infoLight: '#11A5F3', // blue-300
  infoDark: '#0B5297', // blue-500
  accent: '#14B597', // teal-400
  accentLight: '#35C6AB', // teal-300
  accentDark: '#09A084', // teal-500
  actionHover: '#30415C', // navyblue-350
  actionSelected: '#3E516B', // navyblue-300
  actionDisabled: '#4F4F4F', // gray-600
  actionFocus: '#86A3C3', // navyblue-100
  overlayLight: 'rgba(0, 0, 0, 0.3)',
  overlayMedium: 'rgba(0, 0, 0, 0.5)',
  overlayDark: 'rgba(0, 0, 0, 0.7)',
  linkProminent: '#7FD3FF', // blue-200
  linkProminentHover: '#ACE2FF', // blue-100
  linkNeutral: '#BDBDBD', // gray-300
  linkNeutralHover: '#FFFFFF', // white
  linkDiscreet: '#DEDEDE', // gray-200
  linkDark: '#3E516B', // navyblue-300
  linkDarkHover: '#4F627C', // navyblue-200
} as const;

export default tokensDark;
